import { Outlet } from "react-router";
import { DashboardSidebar } from "@/screens/dashboard/side-bar";
import { SidebarProvider, useSidebar } from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { WaypointDetailsSidebar } from "@/screens/dashboard/waypoint-details-sidebar";
import { useSelectedWaypointStore } from "./selected-waypoint.store";

function DashboardContent() {
  const { state, toggleSidebar } = useSidebar();
  const { tripId, waypointId, clearSelectedWaypoint } =
    useSelectedWaypointStore();

  // Determine if we should show the waypoint details sidebar
  const showWaypointDetails = state === "expanded" && tripId && waypointId;

  // Calculate the width of the dashboard sidebar
  const dashboardSidebarWidth = state === "expanded" ? 380 : 48;

  // Calculate the total width for positioning the toggle button
  const totalWidth = showWaypointDetails
    ? dashboardSidebarWidth + 400 // Dashboard width + Waypoint details width
    : dashboardSidebarWidth;

  return (
    <div className="flex h-screen w-full">
      <div className="flex h-full relative">
        {/* Dashboard sidebar */}
        <div className="h-full">
          <DashboardSidebar />
        </div>

        {/* Waypoint details sidebar - only show when expanded and waypoint is selected */}
        {showWaypointDetails && (
          <div
            className="h-full"
            style={{
              position: "absolute",
              left: `${dashboardSidebarWidth}px`,
              top: 0,
              zIndex: 10,
            }}
          >
            <WaypointDetailsSidebar onClose={clearSelectedWaypoint} />
          </div>
        )}

        {/* Toggle button - positioned after the last visible sidebar */}
        <Button
          variant="ghost"
          className="absolute top-6 z-50 bg-white shadow-md border hover:bg-gray-100 h-[45px] w-[23px] p-0 rounded-none rounded-r"
          style={{
            left: `${totalWidth}px`,
          }}
          onClick={toggleSidebar}
        >
          {state === "expanded" ? (
            <ChevronLeft className="h-4 w-4" />
          ) : (
            <ChevronRight className="h-4 w-4" />
          )}
        </Button>
      </div>

      {/* Main content area */}
      <div className="relative flex-1 h-full">
        <Outlet />
      </div>
    </div>
  );
}
export function DashboardLayout() {
  return (
    <SidebarProvider>
      <DashboardContent />
    </SidebarProvider>
  );
}
